import React from "react";

import { useRouteMatch, Switch, Route } from "react-router-dom";
import { SoilsView } from "../components/SoilsView";

export const SoilRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/:field`}>
                <SoilsView />
            </Route>
            <Route path={`${path}`}>
                <SoilsView />
            </Route>
        </Switch>
    );
}
